import log from "cslog";
import produce from "immer";

export function applyOGColor(one) {
    log.d(one, "one in applyOGColor");

    const ogColors = one?.others?.ogColors;
    if (!ogColors) {
        return false;
    }

    log.d(ogColors, "ogColors in applyOGColor");

    const html = one?.data?.pages?.[0]?.html;
    log.d(html, "html in applyOGColor");

    if (!html) {
        return false;
    }

    const out = produce(html, (draft) => {
        Object.keys(draft).forEach((key) => {
            if (ogColors[key]) {
                draft[key] = updateElement(draft[key], ogColors[key]);
            }
        });
    });

    log.d(out, "out html in applyOGColor");
    return {
        ...one,
        data: {
            ...one?.data,
            pages: [
                {
                    ...one?.data?.pages?.[0],
                    html: out,
                },
            ],
        },
    };
}

function updateElement(element, newVals) {
    const etype = element?.type;
    switch (etype) {
        case "shape":
            return {
                ...element,
                input: {
                    ...(element?.input || {}),
                    ...(newVals?.backgroundColor
                        ? {
                              fill: {
                                  type: "simple",
                                  value: newVals?.backgroundColor,
                              },
                          }
                        : {}),
                },
            };
        case "graphic":
            return {
                ...element,
                input: {
                    ...(element?.input || {}),
                    ...(newVals?.color_array
                        ? {
                              svgSource: {
                                  ...(element?.input?.svgSource || {}),
                                  colors: newVals?.color_array,
                              },
                          }
                        : {}),
                },
            };
        default:
            return {
                ...element,
                style: {
                    ...(element?.style || {}),
                    ...(newVals?.color ? { color: newVals?.color } : {}),
                    ...(newVals?.backgroundColor
                        ? {
                              background: {
                                  type: "simple",
                                  value: newVals?.backgroundColor,
                              },
                          }
                        : {}),
                },
            };
    }
}
